// var ol = omjs.ol;

/* 
    polygon_fill
    polygon_border_width
    polygon_border_color
*/

// var toRGBAstring = function(array) {
//     return 'rgba('+ array.join(',') +')';
// };

module.exports = function(style, zindex, scale) {

    // кружок для рисования
    var circle = new ol.style.Circle({
        radius: style['polygon_border_width'],
        fill  : new ol.style.Fill({
            color: style['polygon_fill']
        }),
        stroke: new ol.style.Stroke({
            color: style['polygon_border_color'],
            width: style['polygon_border_width'],
            // linedash: style['line_border_style']
        })
    });

    /* стиль для дополнительной обводки */
    var additional = new ol.style.Style({
        stroke: new ol.style.Stroke({
            color: style['polygon_fill'],
            width: style['polygon_border_width'],
            // linedash: style['line_border_style']
        }),
        zIndex: zindex
    });

    /* обычный стиль */
    var regular = new ol.style.Style({
        fill  : new ol.style.Fill({
            color: style['polygon_fill']
        }),
        stroke: new ol.style.Stroke({
            color: style['polygon_border_color'], // цвет линии
            width: style['polygon_border_width'], // толщина линии
            // linedash: style['line_border_style']
        }),
        image : circle,
        zIndex: zindex
    });

    return [additional, regular];
};



//////////////////
// WEBPACK FOOTER
// ./src/View/PublicMapDraw/polygon-style.js
// module id = 233
// module chunks = 0